"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var wildfires_1 = require("../../store/reducers/wildfires");
var map_1 = require("../../store/reducers/map");
var WildfireLayer_1 = __importDefault(require("./WildfireLayer"));
var AppConfig_1 = require("../../AppConfig");
var WildfireLayerContainer = function (_a) {
    var mapView = _a.mapView;
    var dispatch = react_redux_1.useDispatch();
    var definitionExpression = react_redux_1.useSelector(wildfires_1.definitionExpressionSelector);
    var classBreakRenderer = react_redux_1.useSelector(map_1.wildfireLayerRendererSelector);
    var feature2FlyTo = react_redux_1.useSelector(wildfires_1.feature2FlyToSelector);
    var feature2OpenPopup = react_redux_1.useSelector(wildfires_1.feature2OpenPopupSelector);
    var WildfiresLayerUrl = AppConfig_1.MapConfig.WildfiresLayerUrl;
    var visibleFeaturesOnChange = function (ids) {
        dispatch(wildfires_1.updateVisibleFeatures(ids));
    };
    return classBreakRenderer ? (React.createElement(WildfireLayer_1.default, { mapView: mapView, url: WildfiresLayerUrl, definitionExpression: definitionExpression, classBreakRendererInfo: classBreakRenderer, feature2FlyTo: feature2FlyTo, feature2OpenPopup: feature2OpenPopup, visibleFeaturesOnChange: visibleFeaturesOnChange })) : null;
};
exports.default = WildfireLayerContainer;
